// The Creative Code Studio project kinds that run in the playground
// (creative-code-studio-website-prd D-WEB-01, creative-code-studio-chatbot-prd
// D-CB-01/02). ONE exported union replaces the inline `'game' | 'website'`
// unions that used to live in every pane, so adding a kind is a one-line change
// here plus the kind-specific label/runtime seams — never a sweep of ~10 files.
//
//   game     — the Phaser / three.js game runtime (GameFrame).
//   website  — the multi-page site runtime with a real server-side db (SiteFrame).
//   chatbot  — a SUPERSET of website: the same site runtime plus the `window.ai`
//              chat bridge to the kid's bot brain (D-CB-02 / D-CB-06).

export type StudioKind = 'game' | 'website' | 'chatbot';

/** The kinds the WEBSITE runtime serves — SiteFrame, the Database window, the
 *  Reload-only runner chrome, the kind-aware site linter and Guide. A chatbot
 *  IS a website with a chat bridge on top, so every "isSite" gate reads
 *  through here instead of comparing against `'website'` (D-CB-02). */
export function isWebsiteRuntimeKind(kind: StudioKind | string | null | undefined): boolean {
  return kind === 'website' || kind === 'chatbot';
}

/** Normalise a raw wire kind (`Project.kind` from the backend, a `?kind=` query
 *  param, a frozen share kind) to a StudioKind. Unknown / absent → `game`, the
 *  pre-kind default every existing caller relied on. */
export function toStudioKind(raw: unknown): StudioKind {
  return raw === 'website' || raw === 'chatbot' ? raw : 'game';
}

/** Kid-facing noun for the thing being built ("game" / "website" / "chatbot"). */
export function studioKindNoun(kind: StudioKind): string {
  return kind;
}
